

















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import gmapsInit from '@/_services/gmap.service'
import MapAdjust from '@/_services/map.adjust.service'
import MapLabel from '@/_services/map-label.service'
import RawOverlay from '@/_services/raw.overlay.service'
import config from '@/_services/config'
import _ from 'lodash'
import FloorModel from '@/_models/FloorModel'

let google: any = {}
let map: any = {}

@Component({
  components: {},
  computed: {},
})
export default class GeofenceMapAdjust extends Vue {
  // Props
  @Prop()
  data!: any
  // data
  searchQuery: string = 'Tokyo Japan'
  swLat: any = 0
  swLon: any = 0
  neLat: any = 0
  neLon: any = 0
  angle: any = 0
  zoom: any = 0
  floorOpacity: any = 0
  floorFile: string = ''
  overlay: any = null
  loadingComponent: any = null

  rectangleFloor: any = null
  searchFloorQuery: string = ''
  selectedFloor: FloorModel = new FloorModel()
  mapLabel: any

  get floors(): FloorModel[] {
    return this.$store.state.floors.all.items
  }

  get filteredFloors(): FloorModel[] {
    if (!this.floors) {
      return []
    }

    return this.floors.filter((item: FloorModel): boolean => {
      return (
        String(item.name)
          .toLowerCase()
          .indexOf(this.searchFloorQuery.toLowerCase()) !== -1
      )
    })
  }

  @Watch('floorOpacity')
  async changeOpacity() {
    this.setFloorOpacity()
  }

  setFloorOpacity(): void {
    const el = document.getElementById('floorMapImg')
    if (!el) {
      return
    }

    el.style.opacity = (this.floorOpacity / 100).toString()
  }

  handleSelectFinished(): void {
    const data = {
      geofence_sw_lat: this.swLat,
      geofence_sw_lon: this.swLon,
      geofence_ne_lat: this.neLat,
      geofence_ne_lon: this.neLon,
      geofence_angle: this.angle,
      geofence_map_zoom: this.zoom,
      geofence_opacity: this.floorOpacity,
    }

    this.$emit('mapAjustDone', data)
  }

  drawMapOverlay() {
    const bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(this.swLat, this.swLon),
      new google.maps.LatLng(this.neLat, this.neLon)
    )

    const overlayOptions = {
      angle: this.angle,
      floorFile: '',
      floorOpacity: this.floorOpacity,
    }

    this.overlay = MapAdjust(this, google, bounds, map, overlayOptions)
  }

  handleMoveFloorToHere() {
    try {
      const center = map.getCenter()
      const centerLat = center.lat()
      const centerLon = center.lng()
      const tmpLat = (this.swLat - this.neLat) / 2
      this.swLat = centerLat + tmpLat
      this.neLat = centerLat - tmpLat

      const tmpLon = (this.swLon - this.neLon) / 2
      this.swLon = centerLon + tmpLon
      this.neLon = centerLon - tmpLon

      this.overlay.onRemove()
      this.drawMapOverlay()
    } catch (error) {
      console.error(error)
    }
  }

  handleSelectFloor(selectedFloor: FloorModel) {
    if (
      !selectedFloor ||
      !selectedFloor.floor_sw_lat ||
      !selectedFloor.floor_sw_lon
    ) {
      return
    }

    this.selectedFloor = selectedFloor
    this.displayFloorPostion(selectedFloor)
  }

  displayFloorPostion(selectedFloor: FloorModel) {
    const lat = (selectedFloor.floor_sw_lat + selectedFloor.floor_ne_lat) / 2
    const lng = (selectedFloor.floor_sw_lon + selectedFloor.floor_ne_lon) / 2

    // reset rectangle before create new
    if (this.rectangleFloor) {
      this.rectangleFloor.onRemove()
    }

    if (this.mapLabel) {
      this.mapLabel.onRemove()
    }

    map.setCenter(new google.maps.LatLng(lat, lng))

    // this.drawFloorOverLay()
    this.rectangleFloor = RawOverlay(google, map, selectedFloor)

    this.mapLabel = new MapLabel(this, google, map, {
      text: selectedFloor.name,
      position: new google.maps.LatLng(lat, lng),
      fontSize: 16,
    })
  }

  async displayMap() {
    try {
      const el = document.getElementById('adjustMap')
      if (el === null) {
        return
      }
      this.showLoading()
      const center = this.getCenterMap()

      google = await gmapsInit()
      map = new google.maps.Map(el, {
        center,
        zoom: this.zoom,
        tilt: 0,
        clickableIcons: false,
        rotateControl: false,
        streetViewControl: false,
      })

      this.drawMapOverlay()

      google.maps.event.addListener(map, 'zoom_changed', () => {
        this.zoom = map.zoom
      })

      this.hideLoading()
      this.setFloorOpacity()
    } catch (error) {
      console.error(error)
    }
  }

  showLoading(): void {
    this.loadingComponent = this.$buefy.loading.open({})
  }

  hideLoading(): void {
    if (this.loadingComponent) {
      this.loadingComponent.close()
    }
  }

  setDataFromAdjustMap(data: any) {
    this.swLat = data.floor_sw_lat
    this.swLon = data.floor_sw_lon
    this.neLat = data.floor_ne_lat
    this.neLon = data.floor_ne_lon
    this.angle = data.floor_angle

    this.zoom = data.floor_map_zoom
    if (typeof data.floor_opacity !== 'undefined') {
      this.floorOpacity = data.floor_opacity
    }
  }

  searchPlace() {
    const loadingComponent = this.$buefy.loading.open({})
    const keyword = this.searchQuery.replace(' ', '+')
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?key=${config.googleApiKey.geoCode}&address=${keyword}`
    fetch(apiUrl)
      .then((resp) => {
        resp.text().then((text: string) => {
          const responseJson: any = text && JSON.parse(text)
          if (responseJson.results && responseJson.results.length) {
            const seachResult = responseJson.results[0].geometry
            map.setCenter(
              new google.maps.LatLng(
                seachResult.location.lat,
                seachResult.location.lng
              )
            )
          } else {
            this.$buefy.toast.open({
              message: this.$t('messages.location_not_found') as string,
              type: 'is-danger',
            })
          }

          loadingComponent.close()
        })
      })
      .catch((error) => {
        console.log(error)
        loadingComponent.close()
      })
  }

  getCenterMap(): { lng: number; lat: number } {
    return {
      lat: (this.swLat + this.neLat) / 2,
      lng: (this.swLon + this.neLon) / 2,
    }
  }

  // After page created
  mounted() {
    if (this.data) {
      const dataConvert = {
        floor_angle: this.data.geofence_angle,
        floor_map_zoom: this.data.geofence_map_zoom,
        floor_ne_lat: this.data.geofence_ne_lat,
        floor_ne_lon: this.data.geofence_ne_lon,
        floor_opacity: this.data.geofence_opacity,
        floor_sw_lat: this.data.geofence_sw_lat,
        floor_sw_lon: this.data.geofence_sw_lon,
      }
      this.setDataFromAdjustMap(dataConvert)
      this.displayMap()
    }
  }
}
